<!--
   Created by qing on 2020/4/23 3:19 下午
   Des:
-->
<template>
  <div class="temp-form-preview">
    <div class="header" v-if="tempInfo">
      <div
        class="icon"
        :style="{backgroundColor: tempInfo.iconColor || '#0E9EFF'}">
        <i
          class="app-icon"
          :class="tempInfo.appIcon || 'iconfont icon-activity'"
        ></i>
      </div>
      <div class="header__temp-info">
        <h1 class="temp-name">
          {{tempInfo.appName}}
        </h1>
        <p class="sub temp-install">
          已安装{{tempInfo.installCount}}次
        </p>
      </div>
      <van-button
        v-if="installShowQrcode || ($store.getters.adminInfo && ($store.getters.adminInfo.creator || $store.getters.adminInfo.topAdmin))"
        type="primary"
        size="small"
        @click="onClickInstall">
        安装应用
      </van-button>
    </div>

    <template>
      <div class="form-content" v-if="formSet.isInit">
        <header v-if="formSet.customFormStyle.headerType === FORM_THEME_TYPE_IMAGE">
          <van-image
            width="100%"
            :src="headImage">
          </van-image>
        </header>

        <Fill :formSet="formSet" :hasHeader="true">
        </Fill>
      </div>

      <van-skeleton
        v-else
        style="padding-top: 20px;"
        title
        :row="16">
      </van-skeleton>
    </template>

    <div class="cancel-button" @click="onClickCancel">
      <van-icon name="arrow-left"/>
    </div>

    <van-action-sheet
      v-model="visible"
      :actions="opts"
      get-container="body"
      title="是否需要保留示例数据"
      cancel-text="取消"
      @select="onSelect">
    </van-action-sheet>

    <van-action-sheet
      v-model="companyListVisible"
      :actions="companyList"
      get-container="body"
      title="选择要安装应用的团队"
      cancel-text="取消"
      @select="onSelectCompany">
    </van-action-sheet>

    <van-image-preview
      class="qrcode-preview"
      v-if="tempInfo"
      v-model="showQrcode"
      :images="[tempInfo.smallProgramCode]">
      <template slot="index">长按识别小程序码，安装应用</template>
    </van-image-preview>
  </div>
</template>

<script>
  import Fill from '../../RyForm/redact/Fill'
  import {
    AFTER_JUMP_TYPE__CUSTOM,
    AFTER_JUMP_TYPE__DEFAULT,
    AFTER_JUMP_TYPE__URL,
    FORM_FLOW_NOT_INIT,
    FORM_STATUS__READ,
    FORM_TYPE__FILL, FORM_WRITE_FIELD_REPEAT,
    SUCCESS,
    FORM_THEME_TYPE_IMAGE,
    FORM_THEME_TYPE_COLOR, FORM_STATUS__FILL, FORM_ITEM__MEMBER, FORM_ITEM__DEPARTMENT
  } from '../../RyForm/types'
  import RyFormSet from '../../RyForm'

  export default {
    data() {
      return {
        FORM_THEME_TYPE_IMAGE,
        FORM_THEME_TYPE_COLOR,
        btnList: [],
        formSet: new RyFormSet(),
        tempInfo: null,
        companyId: '',
        appId: '',
        formId: '',

        visible: false,
        companyListVisible: false,
        opts: [
          {
            name: '保留示例数据',
            value: 1,
            // color: 'transparent'
          },
          {
            name: '不保留示例数据',
            value: 0,
            // color: 'transparent'
          },
        ],
        companyList: [],

        // 是否在安装模板时弹出二维码，从手机网页过来需要此参数
        installShowQrcode: 0,
        showQrcode: false
      }
    },
    metaInfo() {
      return {
        title: this.tempInfo ? this.tempInfo.appName : '「轻魔方」轻量级敏捷系统搭建',
        meta: [   // set meta
          {
            name: 'description',
            content: this.tempInfo ? this.tempInfo.appDes : ''
          }
        ]
      }
    },
    created() {

      this.companyId = this.$route.query.companyId
      this.appId = this.$route.query.appId
      this.formId = this.$route.query.relateId
      this.installShowQrcode = this.$route.query.installShowQrcode || 0

      this.formSet.companyId = this.companyId
      this.formSet.appId = this.appId
      this.formSet.formId = this.formId

      this.$store.dispatch('getTemplateInfo', this.$route.query.appId)
        .then(res => {
          this.tempInfo = res
        }).catch(console.error)
        .finally(() => {
          this.loading = false
        })

      this.$store.dispatch('getTempFormStructure', {formId: this.formId, appId: this.appId})
        .then(structure => {
          this.formSet.setStructure(structure)
          this.formSet.status = FORM_STATUS__FILL
          return this.$store.dispatch('getTempFormDetail', {
            ...this.formSet.getIds(),
            formId: this.formId,
            appId: this.appId
          })
        })
        .then(resultObject => {
          this.formSet.setConf(resultObject)
          Object.keys(this.formSet.fields).forEach(key => {
            const field = this.formSet.fields[key]
            if (field.type === FORM_ITEM__MEMBER || field.type === FORM_ITEM__DEPARTMENT) {
              field.hidden = 1
            }
          })
          this.formSet.isInit = true
        })
        .catch(err => {
          console.error(err)
        })
    },
    computed: {
      headImage() {
        const headImg = this.formSet.customFormStyle.headerImage
        return headImg ? headImg : `${this.$BASE_PATH}/fetch/image?id=437649976726651087.png`
      }
    },
    components: {
      Fill
    },
    methods: {

      // 安装应用
      onClickInstall() {
        if (!this.$store.getters.userInfo) {
          // this.$router.push({
          //   name: 'installTempForward',
          //   query: {
          //     tempId: this.tempInfo.appId
          //   }
          // })
          const returnurl = encodeURIComponent(location.href)
          location.replace(`${location.origin}${this.$FORWARD_BASE_PATH}/#/mini/login?returnurl=${returnurl}&appId=${this.$route.query.appId}`)
          return
        }
        const company = this.$store.getters.company
        if (company) {
          this.$store.dispatch('reqInstallCompanyList')
            .then(companyList => {
              const installCompanys = companyList.filter(item => item.hasInstallPer)
              if (installCompanys && installCompanys.length) {

                this.companyList.splice(0, this.companyList.length)
                companyList.forEach(company => {
                  if (company.hasInstallPer) {
                    this.companyList.push({
                      ...company,
                      name: company.companyName,
                      // color: 'transparent'
                    })
                  }
                })

                const companyInfo = companyList.filter(item => item.companyId === company.companyId)[0]
                // 判断当前团队是否有安装权限
                if (companyInfo && companyInfo.hasInstallPer) {
                  // 弹出选择安装数据弹窗
                  this.visible = true
                } else {
                  // 没有安装权限。选团队
                  this.companyListVisible = true
                }
              } else {
                // 没有可以安装模板的团队、弹出选择安装数据弹窗、直接进入下一步，创建团队并安装
                this.$store.commit('UPDATE__COMPANY', null)
                this.visible = true
              }
            }).catch(console.error)

        } else {
          this.visible = true
        }
      },
      // 选择数据后安装应用
      onSelect(item) {
        if (this.$store.getters.userInfo) {
          // 登陆过
          this.$store.dispatch('actionNodeSave', {
            tempList: [
              {
                tempId: this.tempInfo.appId,
                tempName: this.tempInfo.appName
              }
            ],
            userInfo: this.$store.getters.userInfo,
            companyInfo: this.$store.getters.company,
            installData: item.value
          }).then(res => {
            // if (window.isWxWork || window.isLark) {
            //   this.$router.push({
            //     name: 'installTemp',
            //     query: {
            //       key: res.nodeKey
            //     }
            //   })
            // } else {
            //   // 跳转到小程序安装应用页面
            //   this.$wx.miniProgram.redirectTo({url: `/pages/install_temp/index?key=${res.nodeKey}`})
            // }
            if (!this.$store.getters.env || this.$store.getters.env === 'smallProgram') {
              // 跳转到小程序安装应用页面
              this.$wx.miniProgram.redirectTo({url: `/pages/install_temp/index?key=${res.nodeKey}`})
            } else {
              this.$router.push({
                name: 'installTemp',
                query: {
                  key: res.nodeKey
                }
              })
            }
          }).catch(console.error)

        } else {
          // 未登陆
          this.$dialog.confirm({
            title: '',
            message: '安装模板需要您先创建一个账户。',
          })
            .then(() => {
              this.$wx.miniProgram.redirectTo({url: `/pages/temp_center_login/index?tempId=${this.tempInfo.appId}`})
            })
            .catch(() => {
            });
        }
      },
      // 选择公司进行安装
      onSelectCompany(item) {
        this.$store.commit('UPDATE__COMPANY', item)
        this.visible = true
      },
      onClickCancel() {
        // this.$router.push({
        //   name: 'tempPreview',
        //   query: {
        //     appId: this.$route.query.appId
        //   }
        // })
        this.$router.go(-1)
      }
    }
  };
</script>

<style lang="less">
  .temp-form-preview {
    box-sizing: border-box;
    height: calc(100% - env(safe-area-inset-bottom));
    display: flex;
    flex-direction: column;
    background-color: #fff;

    .header {
      height: 60px;
      display: flex;
      justify-content: space-between;
      padding: 10px;
      border-bottom: 1px solid #e6e6e6;

      .icon {
        float: left;
        width: 40px;
        height: 40px;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 10px;

        .app-icon {
          font-size: 34px;
          color: #ffffff;
        }
      }
      .header__temp-info {
        flex: 1;
        position: relative;

        .temp-name {
          width: 100%;
          position: absolute;
          font-size: 18px;
          margin-bottom: 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-weight: bold;

        }

        .sub {
          position: absolute;
          width: 100%;
          color: #959699;
          font-size: 12px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .temp-des {
          margin-top: 30px;
        }

        .temp-install {
          margin-top: 30px;
        }
      }

      .van-button {
        margin-top: 8px;
        width: 100px;
      }
    }

    .form-content {
      height: calc(100% - 60px);
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;

      > header {
        background-color: rgba(0, 0, 0, 0.2);
        position: relative;

        > .form-set__title {
          box-sizing: border-box;
          font-size: 20px;
          font-weight: bold;
          color: #FFFFFF;
          position: absolute;
          top: 50%;
          text-align: center;
          width: 100%;
          transform: translateY(-50%);
          line-height: 40px;
          padding: 0 36px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        > .form-set__des {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          font-size: 12px;
          color: #ffffff;
          background-color: rgba(0, 0, 0, 0.4);
          padding: 0 16px;
          line-height: 30px;
          height: 30px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }

    .cancel-button {
      width: 30px;
      height: 30px;
      border: 1px solid #e6e6e6;
      border-radius: 50%;
      position: fixed;
      top: 40px;
      left: 10px;
      background-color: rgba(0, 0, 0, 0.4);
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 100;
    }

    .qrcode-preview {

      .van-image-preview__image {
        top: 20%;

        img {
          background-color: #fff;
          height: auto;
        }
      }

      .van-image-preview__index {
        width: 100%;
        margin-top: 50px;
        left: 0;
        transform: none;
        text-align: center;
      }
    }
  }

</style>